import React from "react";
import clsx from "clsx";
import { useHistory, Link } from "react-router-dom";
import DoneIcon from "@material-ui/icons/Done";
import "./styles.scss";

interface NavbarLinkProps {
  title: string;
  isActive: boolean;
  changeTab: (tab: string) => void;
  to: string;
  color: string;
  likeButton: boolean;
}

export const NavbarLink = (props: NavbarLinkProps): JSX.Element => {
  const { title, isActive, changeTab, to, color, likeButton } = props;
  const history = useHistory();
  return (
    <button
      type="button"
      className={clsx(
        "navbar-link",
        isActive && "active",
        likeButton && "like-button"
      )}
      onClick={() => {
        history.push(to);
        changeTab(title);
      }}
    >
      <Link to={to}>
        <h6 style={{ color: isActive && !likeButton ? color : undefined }}>
          {title}
        </h6>
      </Link>
      {likeButton && (
        <div>
          <DoneIcon fontSize="inherit" />
        </div>
      )}
    </button>
  );
};
